import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// FAQ data
const helpData = {
  BillPayments: [
    {
      question: "Which bills can we pay through TA Wallet?",
      answer: `You can pay all BHARAT BILL Payments such as DTH, INTERNET, POST PAID Mobile Bills, Mobile Recharge, FASTag Recharge etc. 
We are continuously working towards adding more billers to our platform. Please check the app to confirm that your biller is present. If not, do check back later.`,
    },
    {
      question:
        "I paid a bill which showed successful but failed later, how do I get a refund?",
      answer: `At times, a transaction which shows successful at our end can still fail at the biller’s end for a variety of reasons. We are sorry, we do not control this.

In case this happens, we will refund your money within 3 working days. If refund is not received within this time, Please feel free to contact customer support or write to us at support@taipl.in`,
    },
    {
      question: "My Bill Payment is failed. Why does that happen?",
      answer: `A bill pay can fail due to one of the following reasons:

• Incorrect customer/ billing information entered.
• The biller is not available at that time.
• Biller limit is reached or bill amount entered is incorrect.
• Incorrect payment details entered.

So request you to check your entries and try again.`,
    },
    {
      question: "How long will it take for the bill payment confirmation?",
      answer: `Generally, it takes 2-3 business days for bill payment to get updated at the biller’s end.`,
    },
  ],
};

const Billpayments = ({ selectedSection = "BillPayments" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Billpayments.jpg"
          alt="Bill payments banner"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Bill Payments
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 900,
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Billpayments;
